import { WelcomeVideoStatus } from "../../contracts";

export enum GuideMediaType {
	IMAGE = "image",
	VIDEO = "video"
}

export interface MediaGuideUIProps {
	readonly fileType: GuideMediaType;
	readonly fileName: string | null;
	readonly buttonText: string;
	readonly handleNext?: (status?: WelcomeVideoStatus) => void;
	readonly videoStatus?: WelcomeVideoStatus;
	readonly visible?: boolean;
	readonly loading?: boolean;
	readonly handleVideoTimeUpdate?: (video: HTMLVideoElement | null) => void;
	readonly highlightId?: string;
}
